import React, { useContext } from 'react'
import { NotificationProvider } from './notification-provider'

interface INotificationSuccess {
  data: string
  status: number
  statusText: string
  headers: object
  config: object
  request: object
}

const SuccessBar = ({ success: { message } }: { success: { message: string; updatedAt: number } }) => {
  const notification: any = useContext(NotificationProvider)
  if (message) {
    const objMessage: INotificationSuccess = JSON.parse(JSON.stringify(message))
    if (objMessage.data) {
      notification.addNotification({
        title: objMessage.statusText,
        level: 'success',
        message: objMessage.data
      })
    } else {
      const newObjMessage: { success: string; riderId: string } = JSON.parse(JSON.stringify(message))
      // changed text message logic, so existing notification format will not be affected
      const notificationMessage: any =
        typeof objMessage === 'object' && objMessage !== null && objMessage.hasOwnProperty('success')
          ? newObjMessage.success
          : message

      notification.addNotification({
        title: 'Success',
        level: 'success',
        message: JSON.stringify(notificationMessage)
      })
    }
  }

  return null
}

export default SuccessBar



// WEBPACK FOOTER //
// ./src/components/ui/SuccessBar.tsx